import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { getValidatedRedirectFromQuery, safeNavigate } from '../utils/redirectValidator';
import { getRoleHomePath } from '../utils/adminPermissions';
import { setSession } from '../utils/authSession';
import { apiPost } from '../api/client';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [successMessage, setSuccessMessage] = useState(location.state?.message || '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.pathname, location.state, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiPost('/api/auth/login', {
        username,
        password
      });

      setSession({
        accessToken: response.accessToken || response.token,
        user: response.user
      });

      const { resetActivityTracking } = await import('../utils/activityTracker');
      resetActivityTracking();

      const roleHome = getRoleHomePath(response.user?.role);
      const redirectUrl = getValidatedRedirectFromQuery(searchParams, roleHome);
      safeNavigate(navigate, redirectUrl, roleHome);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-shell">
        <div className="admin-login-card">
          <div className="admin-login-brand">
            <img src="/img/tghlogo.png" alt="Tema General Hospital" />
            <div>
              <p className="admin-login-eyebrow mb-1">Secure access</p>
              <h1 className="admin-login-title mb-1">Admin Portal</h1>
              <p className="admin-login-subtitle mb-0">Tema General Hospital</p>
            </div>
          </div>

          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="mb-3">
              <label htmlFor="username" className="form-label">
                Username or Email
              </label>
              <input
                type="text"
                className="form-control"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="btn btn-primary w-100 admin-login-submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
